import {
  backgroundCheckRoutes,
  protectedBackgroundCheckRoutes,
} from './BackgroundCheck';
import {
  catchCheatingPartnerRoutes,
  protectedCatchCheatingPartnerRoutes,
} from './CatchCheatingPartner';
import { landingRoutes, protectedLandingRoutes } from './Landing';
import { landing2Routes, protectedLanding2Routes } from './Landing2';
import { landing3Routes, protectedLanding3Routes } from './Landing3';
import { landing4Routes, protectedLanding4Routes } from './Landing4';
import { landingMetaRoutes, protectedLandingMetaRoutes } from './LandingMeta';
import { newFunnelRoutes, protectedNewFunnelRoutes } from './NewFunnel';
import {
  peopleSearchRoutes,
  protectedPeopleSearchRoutes,
} from './PeopleSearch';
import {
  peopleSearchOnboardingRoutes,
  protectedPeopleSearchOnboardingRoutes,
} from './PeopleSearchOnboarding';

const w2wRoutes = [
  ...landingRoutes,
  ...landingMetaRoutes,
  ...landing2Routes,
  ...landing3Routes,
  ...landing4Routes,
  ...catchCheatingPartnerRoutes,
  ...backgroundCheckRoutes,
  ...peopleSearchOnboardingRoutes,
  ...peopleSearchRoutes,
  ...newFunnelRoutes,
];

const protectedW2wRoutes = [
  ...protectedLandingRoutes,
  ...protectedLandingMetaRoutes,
  ...protectedLanding2Routes,
  ...protectedLanding3Routes,
  ...protectedLanding4Routes,
  ...protectedCatchCheatingPartnerRoutes,
  ...protectedBackgroundCheckRoutes,
  ...protectedPeopleSearchOnboardingRoutes,
  ...protectedPeopleSearchRoutes,
  ...protectedNewFunnelRoutes,
];

const appRoutes = {
  routes: w2wRoutes,
  protectedRoutes: protectedW2wRoutes,
};

export const appW2aRoutes = appRoutes;
